import { LayoutDashboard, Package, ShoppingCart, Users, Wallet, ShieldPlus, Mail } from "lucide-react";

const NAV = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "products", label: "Products", icon: Package, sub: true },
  { key: "orders", label: "Orders", icon: ShoppingCart, sub: true },
  { key: "clients", label: "Clients", icon: Users, sub: true },
  { key: "revenue", label: "Revenue", icon: Wallet, sub: true },
  { key: "admins", label: "Create Admin Login", icon: ShieldPlus },
  { key: "emails", label: "Email Accounts", icon: Mail },
];

export const AdminSidebar = ({ active, onSelect }) => (
  <aside className="lg:w-60 shrink-0" data-testid="admin-sidebar">
    <nav className="flex flex-wrap lg:flex-col gap-1 lg:sticky lg:top-24 bg-white rounded-2xl border border-purple-100 p-2">
      {NAV.map(({ key, label, icon: Icon, sub }) => (
        <button
          key={key}
          data-testid={`admin-nav-${key}`}
          onClick={() => onSelect(key)}
          className={`flex items-center gap-3 whitespace-nowrap rounded-xl text-sm font-medium transition-colors ${
            sub ? "lg:ml-5 px-3 py-2" : "px-3 py-2.5"
          } ${active === key ? "brand-gradient text-white shadow-sm" : "text-purple-900 hover:bg-purple-50"}`}
        >
          <Icon className={sub ? "w-4 h-4" : "w-5 h-5"} />
          {label}
        </button>
      ))}
    </nav>
  </aside>
);
